module.exports = __webpack_public_path__ + "img/dark-mud-decal-21.21e87aa3.png";